import React, { useState } from "react";

import { Box } from "@chakra-ui/react";
import { resendOdpInvite } from "api/individual-user-management";
import { transactionLimitModalHeaderCss } from "features/individuals/individual-details/styles";

import { Button } from "ui/button";
import { customErrorToast, customSuccessToast } from "ui/custom-toast";
import { Modal } from "ui/modal";
import { ModalHeader } from "ui/modal/modal-header";
import { defaultModalCss } from "ui/modal/styles";
import { Heading3, Paragraph3 } from "ui/typography";

import { IResendInviteModalProps } from "./types";

export const ResendInviteModal = (props: IResendInviteModalProps) => {
  const { isOpen, setIsOpen, handleToggleResendInviteModal, email } = props;

  const [isResending, setIsResending] = useState(false);

  const handleResendInvite = async () => {
    try {
      setIsResending(true);
      const { error, message } = await resendOdpInvite({
        email,
      });
      if (error) {
        customErrorToast({
          message,
        });
      } else {
        setIsResending(false);
        customSuccessToast({ message });
      }
      handleToggleResendInviteModal();
    } catch (error) {
      console.error("Error: ", error);
      setIsResending(false);
    }
  };

  return (
    <Modal
      isOpen={isOpen}
      setIsOpen={setIsOpen}
      modalCss={{
        ...defaultModalCss,
        width: "400px",
        // height: "304px",
        padding: "24px",
        gap: "32px",
      }}
      allowOutsideClick={false}
    >
      <Box className="flex flex-col gap-5">
        <ModalHeader
          modalType="approval"
          modalHeaderCss={transactionLimitModalHeaderCss}
        />
        <Box className="flex flex-col gap-2">
          <Heading3
            fontSize="18px"
            lineHeight="28px"
            textColor="#101828"
            fontWeight="600"
          >
            Resend Invite
          </Heading3>
          <Paragraph3
            lineHeight="20px"
            textColor="#475467"
          >
            Please confirm that you want to resend invite to this individual.
          </Paragraph3>
        </Box>
      </Box>
      <Box
        css={{
          //   height: "44px",
          display: "flex",
          alignItems: "center",
          gap: "12px",
        }}
      >
        <Button
          variant="outline"
          textColor="#344054"
          border="1px solid #D0D5DD"
          className="w-[170px]"
          onClick={handleToggleResendInviteModal}
          disabled={isResending}
        >
          Cancel
        </Button>
        <Button
          variant="solid"
          textColor="#ffffff"
          border="1px solid #00535C"
          className="w-[170px]"
          onClick={handleResendInvite}
          disabled={isResending}
          loading={isResending}
          loadingText="Resending..."
        >
          Resend
        </Button>
      </Box>
    </Modal>
  );
};
